module.exports = __webpack_public_path__ + "static/media/dicon.985102a8.pdf";